import { CommonModule, JsonPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzProgressSpinnerModule } from '@blk/daisy/core/loading';
import { dzChoice, dzInsights, dzMaintenance, DzPictogramsModule, dzSeek, dzTarget, dzTime } from '@blk/daisy/core/pictograms';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { DialogComponent } from './dialog/dialog.component';
import { LoadingDialogComponent } from './templates/loading-dialog/loading-dialog.component';
import { SimpleDialogComponent } from './templates/simple-dialog/simple-dialog.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		CwpNgFrameworkModule,
		AnalyticsModule,
		DzButtonModule,
		DzProgressSpinnerModule,
		GenericDirectivesModule,
		DzPictogramsModule.register(dzInsights, dzMaintenance, dzTarget, dzChoice, dzSeek, dzTime)
	],
	declarations: [DialogComponent, SimpleDialogComponent, LoadingDialogComponent],
	exports: [DialogComponent, LoadingDialogComponent],
	providers: [JsonPipe]
})
export class DialogModule { }
